// If you modify this, make sure to modify it in the CSS file as well
// and make sure that CSS file is included in the app
export const ALLOW_CONTEXT_MENU_CLASS = "__allow-context-menu"
globalThis.document?.addEventListener("contextmenu", (e) => {
    if (e.target instanceof HTMLElement && (e.target.classList.contains(ALLOW_CONTEXT_MENU_CLASS) || e.target.closest(`.${ALLOW_CONTEXT_MENU_CLASS}`))) {
        return
    }
    e.preventDefault()
})